import { render, staticRenderFns } from "./WeeklyCompliance.vue?vue&type=template&id=5e34d9d8&"
import script from "./WeeklyCompliance.vue?vue&type=script&lang=js&"
export * from "./WeeklyCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports